<p-blockUI [blocked]="block"></p-blockUI>
<div style="margin: 20px; min-width: 800px; min-height: 700px">
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <label>Imię i nazwisko*:</label>
      <input pInputText maxlength="64" name="name" [(ngModel)]="currentUser.name"/>
    </div>
    <div class="ui-g-12">
      <label>Nazwa firmy najemcy*:</label>
      <input pInputText maxlength="64" name="companyName" [(ngModel)]="currentUser.companyName"/>
    </div>
    <div class="ui-g-12">
      <label>Telefon:</label>
      <input pInputText maxlength="32" name="telephone" [(ngModel)]="currentUser.telephone"/>
    </div>
    <div class="ui-g-12">
      <label>E-mail*:</label>
      <input pInputText maxlength="128" name="email" [(ngModel)]="currentUser.email"/>
    </div>
    <div class="ui-g-12">
      <label>Aktywny:</label>
      <p-checkbox name="active" binary="true" [(ngModel)]="currentUser.active"></p-checkbox>
    </div>
    <div class="ui-g-12">
      <label>Login*:</label>
      <input pInputText maxlength="128" name="email" [(ngModel)]="currentUser.login" />
    </div>
    <div class="ui-g-12">
      <span style="float: right;">
        <p-button class="button" (click)="cancel()" label="Zamknij"></p-button>
        <p-button class="button" *ngIf="currentUser.id && currentUser.email" (click)="resetPassword()" label="Reset hasła"></p-button>
        <p-button class="button" (click)="save()" label="Zapisz"></p-button>
      </span>
    </div>
  </div>
</div>
